import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const swal = withReactContent(Swal)

export const showErrorMessage = (res) => {
	let message = res ? (res.error ? res.error : JSON.stringify(res.error)) : {}

	message =
		typeof message != 'string'
			? 'Ha ocurrido un error. Favor de contactar el administrador del sistema.'
			: message

	swal
		.fire({
			title: '¡Advertencia!',
			text: message,
			icon: 'error',
			showCancelButton: true,
			cancelButtonText: 'Cerrar',
		})
		.then((result) => {
			if (result.dismiss === swal.DismissReason.cancel) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.close) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.backdrop) {
				swal.close()
			}
		})
}

export const showSuccessMessage = (res) => {
	const message =
		typeof res != 'string'
			? 'Ha ocurrido un error. Favor de contactar el administrador del sistema.'
			: res

	swal
		.fire({
			title: '¡Acción Realizada!',
			text: message,
			icon: 'success',
			showCancelButton: true,
			cancelButtonText: 'Cerrar',
		})
		.then((result) => {
			if (result.dismiss === swal.DismissReason.cancel) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.close) {
				swal.close()
			} else if (result.dismiss === swal.DismissReason.backdrop) {
				swal.close()
			}
		})
}

export const showInfoMessage = (res, duration = 4000) => {
	const message = typeof res === 'string' ? res : 'Procesando...'
	
	Swal.fire({
		title: '',
		text: message,
		icon: 'info',
		toast: true,
		position: 'top-end',
		showConfirmButton: false,
		timer: duration,
		timerProgressBar: false,
		background: '#e3f2fd',
		color: '#1565c0',
		iconColor: '#1565c0'
	})
}

export const showLoadingMessage = (message = 'Enviando...') => {
	Swal.fire({
		title: message,
		html: '<div style="text-align:center;"><div class="swal2-spinner swal2-center" style="display:flex;justify-content:center;align-items:center;margin-top:20px;"><div class="swal2-icon-container"><div class="swal2-loader"></div></div></div></div>',
		allowOutsideClick: false,
		allowEscapeKey: false,
		showConfirmButton: false,
		showCancelButton: false,
		showCloseButton: false,
	})
}

export const closeLoadingMessage = () => {
	Swal.close()
}
